import React from "react"
import lightning from "../img/icon-lightning.inline.svg"
import hand from "../img/icon-hand.inline.svg"
import star from "../img/icon-star.inline.svg"
import statistics from "../img/icon-statistics.inline.svg"
import heart from "../img/icon-heart.inline.svg"
import phone from "../img/icon-phone.inline.svg"
import exclamation from "../img/icon-exclamation.inline.svg"
import graph from "../img/icon-graph.inline.svg"
import mail from "../img/icon-mail.inline.svg"
import magnifier from "../img/icon-magnifier.inline.svg"
import eye from "../img/icon-eye.inline.svg"
import pulse from "../img/icon-pulse.inline.svg"
import network from "../img/icon-network.inline.svg"

const icons = {
  lightning,
  hand,
  star,
  statistics,
  heart,
  phone,
  exclamation,
  graph,
  mail,
  eye,
  magnifier,
  pulse,
  network,
}

const Icon = ({ icon, style, className }) => {
  const SelectedIcon = icons[icon] ?? star
  return <SelectedIcon style={style} className={`icon ${className ?? ""}`} />
}

export default Icon
